import { UseQueryResult } from "@tanstack/react-query";
import { createContext, useContext } from "react";

export interface RecordViewContextValue {
  translationKey: string;
  query: UseQueryResult<Record<string, unknown>>;
}

const RecordViewContext = createContext<RecordViewContextValue>({
  translationKey: "",
  query: {
    data: undefined,
    isLoading: false,
    isError: false,
  } as UseQueryResult<Record<string, unknown>>,
});

export default RecordViewContext;

export const useRecordViewContext = () => {
  const context = useContext(RecordViewContext);
  if (context === undefined) {
    throw new Error(
      "RecordViewContext must be used within a RecordViewContextProvider",
    );
  }
  return context;
};
